import { h } from "preact";
import { Tooltip } from "antd";
import { VENDOR_MAPPING, DEFAULT_VENDOR_INFO } from "../constants/vendors";

export const getVendorInfo = (vendorCode) => {
    if (!vendorCode) {
        return null;
    }
    return VENDOR_MAPPING[vendorCode] || { ...DEFAULT_VENDOR_INFO, name: vendorCode };
};

const VendorDisplay = ({ vendorCode, showName = false, iconSize = 16, gap = "8px" }) => {
    if (!vendorCode) {
        return "-";
    }

    const vendorInfo = getVendorInfo(vendorCode);
    const IconComponent = vendorInfo.Icon;

    return (
        <Tooltip title={vendorInfo.name}>
            <span style={{ display: "flex", gap, alignItems: "center" }}>
                {IconComponent && <IconComponent size={iconSize} />}
                {showName && vendorInfo.name}
            </span>
        </Tooltip>
    );
};

export default VendorDisplay;
